import moviesReducer from "./moviesReducer";
import usersReducer from "./usersReducer";
import { combineReducers } from "redux";

export default combineReducers({
  moviesReducer,
  usersReducer
})